import Vue from 'vue'
import App from './App.vue'
import VCharts from 'v-charts';
import './styles/tq-style.css'
import './fonts/iconfont.css'
import './styles/app.css';
import VueBus from 'vue-bus';
import dataV from '@jiaminghi/data-view';

Vue.use(VueBus);
Vue.use(dataV);
import Element from 'element-ui'
import './styles/element-variables.scss'
Element.Dialog.props.closeOnClickModal['default'] = false;
Element.Dialog.props.closeOnPressEscape['default'] = false;

import '@/styles/index.scss' // global css
import 'jquery';
import store from './store'
import router from './router'

import './permission';
import './utils/time';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.use(Element, {
    size: 'medium', // set element-ui default size
})
Vue.use(VCharts);

new Vue({
    render: h => h(App),
    store,
    router
}).$mount('#app')
